var BookActionSection = require("components/reading/books/BookActionSection");
var BookActionModal = require("components/reading/books/BookActionModal");
var CurrentUser = require("lib/account/CurrentUser");
var DateSpanSelector = require("components/data/DateSpanSelector");
var GoldenEgg = require("components/games/GoldenEgg");

var Features = require("lib/account/Features");
var Glyphicon = require("components/utility/icons/Glyphicon");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var Spinner = require("components/utility/Spinner");
var StudentAvatar = require("components/avatars/StudentAvatar");
var StudentMetrics = require("lib/data/StudentMetrics");
var StudentProgressDisplay = require("components/users/students/StudentProgressDisplay");
var SaleModal = require("components/games/SaleModal");
var ShopSales = require("lib/games/ShopSales");
var StudentTasks = require("components/users/students/StudentTasks");

var StudentOnboardingModal = require("components/users/students/onboarding/StudentOnboardingModal");

var moment = require("moment");
import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { Scrollbars } from 'react-custom-scrollbars';

require("users/students/student_home_page_streamlined.scss");
require("users/students/student_progress_display.scss");


@connect(
  (state, props) => ({
    student: RosterSelectors.student({ state, id: props.match.params.id }),
    showLogReading: Features.isEnabled(Features.LOG_READING),
    showExercises: Features.isEnabled(Features.DIGITAL_EXERCISES),

    hasTasks: RosterSelectors.studentTaskCount({ state, studentID: props.match.params.id }) > 0
  }),
  (dispatch, props) => ({
    populateData: (startDate, endDate) => {
      var studentID = props.match.params.id;

      var fetchStudent = () => {
        if (CurrentUser.hasID(studentID)) {
          var embeds = [
            "student.expectations_progress", "student.prefs",
            "student.expectations_date_spans", "student.perks",
            "student.is_clickable_egg", "current_tasks"
          ];

          if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
            embeds = embeds.concat([
              "task.subject", "activity.format_summary"
            ]);
          }

          if (Features.isEnabled(Features.CLOZE_ASSESSMENTS)) {
            embeds = embeds.concat([
              "student.cloze_status"
            ]);
          }
        }
        var studentQuery = {};
        if (startDate) {
          studentQuery.expectations_progress_start_date = startDate;
        }
        if (endDate) {
          studentQuery.expectations_progress_end_date = endDate;
        }

        return dispatch(RosterActions.fetchStudent({
          id: studentID, query: studentQuery,
          embeds: embeds
        }))
      }

      // We fetch it here because we need to know if there are pending tasks
      //   (RosterSelectors.studentTaskCount)
      // We actually select the books in StudentTasks
      var fetchRevisables = () => {
        var filters = {
          user_id: studentID,
          revisable: true
        }
        var embeds = ["book.quiz_user_ids", "book.quiz_draft_user_ids"];

        return dispatch(ReadingActions.fetchBookActivity({
          filters, embeds, cache: true
        }))
      }

      var promises = [fetchStudent(), fetchRevisables()];

      return Promise.all(promises);
    },
    postBooks: (book, callback) => {
      CurrentUser.api().postBooks({ book: book }, $wr.apiHandler((response) => {
        callback(response.book)
      }));
    },
  })
)
@providePopulateData({ waitForLoad: true })
class StudentHomePageStreamlined extends React.Component {
  constructor(props) {
    super();
    autobind(this);
    LuckyOrangeClient.tagComponent("StudentHomePageStreamlined");
    this.state = {
      showFindBookSection: false, openActivityType: null,
      selectedActivityID: null
    }
    this.actionModal = React.createRef()
  }

  openBookSearch(activityType, activityID, textProvided) {
    if (textProvided) {
      var redirectURL = "/responses/new?text_id=&activity_id=" + activityID;
      $wr.redirect(redirectURL);
    } else {
      this.setState({ openActivityType: activityType, showFindBookSection: true, selectedActivityID: activityID }, function () {
        $wr.scrollToElement($(this.refs.container).find(".bookActionSection"), 100)
      }.bind(this))
    }
  }
  openBookActivity(activityType, book, isFirst) {
    var goToActivity = function (selBook) {
      if (isFirst) {
        var firstParam = "&first=true";
      } else {
        var firstParam = "";
      }

      if (activityType == "quiz") {
        $wr.redirect("/quiz?text_id=" + selBook.text_id + firstParam);

      } else if (activityType == "question") {
        $wr.redirect("/answers/new?text_id=" + selBook.text_id + firstParam);

      } else if (activityType == "review") {
        $wr.redirect("/reviews/new?text_id=" + selBook.text_id + firstParam);

      } else if (activityType == "exercise") {
        var redirectURL = "/responses/new?text_id=" + selBook.text_id + firstParam;
        if (this.state.selectedActivityID != null) {
          redirectURL += "&activity_id=" + this.state.selectedActivityID;
        }
        $wr.redirect(redirectURL);

      } else if (activityType == "log") {
        this.setState({ logReadingSelectedBook: book }, () => {
          this.setState({ showLogReadingModal: true });
        });
        this.refs.bookSearchModal.hide();

      } else {
        throw "Unknown activity type: " + activityType;
      }
    }.bind(this);

    if (book.text_id) {
      goToActivity(book);
    } else {
      this.props.postBooks(book, goToActivity)
      // CurrentUser.api().postBooks({ book: book }, $wr.apiHandler((response) => {
      // 	goToActivity(response.book);
      // }));
    }
  }

  hideOwls() {
    var user = CurrentUser.get();
    return user.settings && user.settings.hide_owls;
  }
  recentlyCreated() {
    moment(CurrentUser.get().created_at) < moment().subtract(2, "days");
  }

  startDate() {
    var dateSpans = this.props.student.expectations_date_spans;
    return this.state.startDate || dateSpans[0].start
  }
  endDate() {
    var dateSpans = this.props.student.expectations_date_spans;
    return this.state.endDate || dateSpans[0].end
  }

  changeDates(startDate, endDate) {
    this.setState({ startDate, endDate, showFindBookSection: false }, () => {
      this.props.populateData(startDate, endDate)
    });
  }

  isMatchingDateSpan() {
    if (this.props.student && this.props.student.expectations_date_spans) {
      return _.filter(this.props.student.expectations_date_spans, (span) => {
        return (span.start == this.startDate()) && (span.end == this.endDate());
      }).length > 0;
    }
    return false
  }

  showArrow() {
    var progressMade = _.map(this.props.student.expectations_progress, (value) => {
      if (value > 0) {
        return true;
      } else {
        return false;
      }
    })
    return !_.contains(progressMade, true)
  }

  renderDateSelectors() {
    if (this.props.student && this.props.student.expectations_date_spans) {
      var dateSpans = this.props.student.expectations_date_spans;
      return (
        <div className="dateSpanSelectorWrap">
          <DateSpanSelector startDate={this.startDate()} endDate={this.endDate()}
            expectationsSpans={dateSpans}
            onSelectDates={this.changeDates} />
        </div>
      );
    }
  }


  onPickSelect(book) {
    this.setState({ selectedBook: book })
    this.actionModal.current.show();
  }

  render() {
    var student = this.props.student;

    if (student && student.pending_onboarding) {
      var studentOnboardingModal = <StudentOnboardingModal />;
    }

    if (this.props.loadingStudent || !student || !student.prefs ||
      !student.expectations_progress || !student.expectations_date_spans) {

      var progressDisplay = (
        <div>
          <Spinner placeholder={true} scale={1.7} />
        </div>
      );
    } else if (this.isMatchingDateSpan()) {
      var className = "linksContainer";
      var expectations = student.prefs.expectations_metrics;
      var progress = student.expectations_progress;
      var actions = [StudentMetrics.TYPES.QUIZZES_PASSED, StudentMetrics.TYPES.QUESTIONS, StudentMetrics.TYPES.REVIEWS]
      var metricsOnly = _.pluck(expectations, 'metric');

      if (this.props.showLogReading) {
        if (!_.contains(metricsOnly, "minutes") && !_.contains(metricsOnly, "pages")) {
          actions.push("minutes")
        }
      }

      expectations = _.sortBy(expectations, (expectation) => {
        if (expectation.metric == StudentMetrics.TYPES.QUIZZES_PASSED) {
          return "AAA"
        } else {
          return expectation.metric;
        }
      })
      if ((expectations || []).length || (student.cloze_status || {}).trigger) {
        var progressDisplay = _.map(expectations, (expectation) => {
          var metric = expectation.metric;

          if (metric == "days-active") {
            var actionMetric = "questions";
          } else {
            var actionMetric = metric;
          }

          return (
            <a onClick={this.openBookSearch.bind(this, actionMetric, null, false)}
              key={metric}>
              <StudentProgressDisplay
                metric={metric}
                title={StudentMetrics.getLabel(metric)}
                unit={StudentMetrics.getUnit(metric)}
                total={expectation.goal}
                current={progress[metric]}
                actionLabel={StudentMetrics.getActionLabel(metric)}
                openBookSearch={this.openBookSearch.bind(this, actionMetric, null, false)} />
            </a>
          );
        });
        if (student.cloze_status && student.cloze_status.trigger) {
          var rld = student.cloze_status;
          var actionMetric = "challenges";
          var metric = "challenges";
          var rldProgressDisplay = (
            <a onClick={this.openChallenges} href="/cloze"
              key={metric}>
              <StudentProgressDisplay
                metric={metric}
                title={StudentMetrics.getLabel(metric)}
                unit={StudentMetrics.getLabel(metric)}
                current={rld.current}
                total={rld.target}
                actionLabel="" />
            </a>
          )
          progressDisplay.push(rldProgressDisplay)
        }
        if (this.props.showExercises) {
          actions.push("exercises");
        }
        if (this.showArrow()) {
          var arrow = (<Glyphicon icon="chevron-right" className="arrow" />)
        }
      } else {
        var className = "emptyStateLinks";
        var emptyDashboard = "emptyDashboard";
        var quizAction = StudentMetrics.TYPES.QUIZZES_PASSED;
        var emptyState = (
          <div className="leftContainer">
            <p>Take a Quiz!</p>
            <a onClick={this.openBookSearch.bind(this, quizAction, null, false)} key={quizAction}>
              <img src={require("action-icons/quizzes-passed-lg.png")} className="" />
            </a>
          </div>
        )
        var emptyStateHeader = (
          <p>Other Things to Do</p>
        )
        actions.shift()
        if (this.props.showExercises) {
          actions.push("exercises");
        }
      }
    } else {
      var progress = student.expectations_progress;
      var progressDisplay = _.map(progress, (amount, metric) => {
        if (metric == "pages") {
          var imageMetric = "minutes";
        } else if (metric == "days-active") {
          var imageMetric = "questions";
        } else {
          var imageMetric = metric;
        }
        return (
          <span className="regularContainer" key={metric}>
            <span className="amount">{amount}</span>
            <p className="metric">{StudentMetrics.getLabel(metric)}</p>
            <img src={StudentMetrics.getIcon(imageMetric)} className="metricIcon" />
          </span>
        );
      });
    }

    var freeActions = _.reject(actions, (action) => {
      return _.contains(metricsOnly, action);
    });

    var linksDisplay = _.map(freeActions, (freeAction) => {
      return (
        <a onClick={this.openBookSearch.bind(this, freeAction, null, false)} key={freeAction}>
          <img src={StudentMetrics.getIcon(freeAction)} className="" />
          {$wr.capitalize(StudentMetrics.getUnit(freeAction))}
        </a>
      )
    })
    var expectations = student.prefs.expectations_metrics;

    if ((expectations || []).length || (student.cloze_status || {}).trigger) {
      var links = (
        <div className={className}>
          {linksDisplay}
        </div>
      )
      var dateSelectors = this.renderDateSelectors();
    } else {
      var emptyLinks = (
        <div className={className}>
          {emptyStateHeader}
          {linksDisplay}
        </div>
      )
    }

    if (this.state.showFindBookSection) {
      var bookSearch = (
        <BookActionSection openBookActivity={this.openBookActivity}
          studentDashboard={true}
          openActivityType={this.state.openActivityType} />
      )
    }

    if (student) {
      if (this.props.hasTasks) {
        var tasksContainer = (
          <StudentTasks onPickSelect={this.onPickSelect}
            onActivitySelect={this.openBookSearch.bind(this, "exercises")} />
        );
        var widerDashboard = "";
        var dividerClassName = "";
      } else {
        var widerDashboard = " widerDashboard";
        var dividerClassName = "eggMargin";
      }

      if (student.is_clickable_egg) {
        var goldenEgg = (
          <GoldenEgg />
        );
      }
    }

    var userForAvatar = CurrentUser.get();
    var dividerSection = (
      <div className={"dividerSection " + dividerClassName}>
        <div className="dividerArea"></div>
        <div className="nameArea">
          <StudentAvatar student={userForAvatar} maxWidth={300} />
          <span className="nameString">
            {student ? $wr.fetchTitle(student) : ""}
          </span>
          {goldenEgg}
        </div>
      </div>
    );

    if (ShopSales.hasCurrentSale() && !this.hideOwls() && !this.recentlyCreated()) {
      var saleModal = (
        <SaleModal ref="saleModal" saleData={ShopSales.getCurrentSale()} />
      );
      var saleBanner = (
        <div onClick={() => { this.refs.saleModal.show() }}
          className="saleBanner">
          <img src={require("misc/halloween-sale-banner.png")} className="bannerImg" />
        </div>
      );
    }

    return (
      <div id="studentHomePageStreamlined" className="container" ref="container">
        {saleModal}{saleBanner}
        {dividerSection}
        {tasksContainer}
        <div className={"dashboardContainer " + emptyDashboard + widerDashboard}>
          {progressDisplay}
          {emptyState}
          {emptyLinks}
          <div>
            {dateSelectors}
            {links}
          </div>
          {bookSearch}
        </div>
        <BookActionModal studentDashboard={true} ref={this.actionModal}
          selectedBook={this.state.selectedBook} openBookActivity={this.openBookActivity}
          expectations={CurrentUser.get().prefs.expectations_metrics} />
        {studentOnboardingModal}
      </div>
    )
  }

  componentDidMount() {
    Mycroft.newEvent({ category: "Student-Profile", action: "show-streamlined-profile" });
    // expand dropdown if url param
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var acceptableParams = ['exercises', 'quizzes-passed', 'reviews', 'questions', 'question-builder']
    var bookSearchDropdown = urlParams.get('bookSearchDropdown')
    if (bookSearchDropdown && acceptableParams.includes(bookSearchDropdown)) {
      this.openBookSearch(bookSearchDropdown, null, false, true);
    }
  }
}

var EXERCISE_TASK = "exercise-task";
var READING_TASK = "reading-task";

StudentHomePageStreamlined.WrappedComponent.propTypes = PageStrictPropTypes({
  populateData: PropTypes.func,
  postBooks: PropTypes.func,
  student: PropTypes.object,
  showLogReading: PropTypes.bool,
  showExercises: PropTypes.bool,
  fetchLibraryPlatforms: PropTypes.func,
  hasTasks: PropTypes.bool
});

module.exports = StudentHomePageStreamlined;


// WEBPACK FOOTER //
// ./modules/components/users/students/StudentHomePageStreamlined.js